import React from 'react';
import Pages from "./Pages/Pages";
import Navigation from "./Pages/Navigation";
import styled from "styled-components";
import {SiCreativecommons} from "react-icons/si";



import {device} from "./components/Devices";


function App() {

    return (
        <div className="App">

            <Main_Container>


                        <Navigation/>
                        <Pages/>

                <footer>
                    <p>Created By <span>Dennis Rijkers</span> |</p>
                    <p><SiCreativecommons style={{marginLeft: "4px", marginRight: "4px"}}/>

                        2022 All Rights Reserved

                    </p>
                </footer>

            </Main_Container>

        </div>
    );
}

export default App;

const Main_Container = styled.div`

  margin: 0;
  padding: 0;
  position: relative;
  top: 0;
  bottom: 0;
  left: 0;
  right: -17px;
  overflow-x: hidden;
  
  overflow-y: auto;
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */

  -webkit-scrollbar {
    display: none;
  }

  width: 100%;
  height: auto;
  max-width: 320px;
  min-width: 320px;
  min-height: 954px;
  max-height: 100%;
  background-color: var(--mainBackGroundColor);
  display: flex;
  flex-direction: column;
  align-items: center;
  //justify-content: center;
  //border-radius: 5px;
  //border: 1px solid black;

  @media ${device.mobileM} {
    max-width: 375px;
  }

  @media ${device.mobileIphone} {
    max-width: 390px;
  }

  @media ${device.mobileL} {

    max-width: 425px;

  }

  @media ${device.tablet} {
    max-width: 768px;
  }

  @media ${device.laptop} {
    max-width: 1024px;
  }

  @media ${device.laptopL} {
    max-width: 1440px;
    height: 1045px;
    max-height: 100%;
  }

  @media ${device.desktop} {
    max-width: 1440px;
    height: 1600px;
    max-height: 1600px;
    margin-top: 50px;
  }
  
  .start_box{

    display: flex;
    flex-direction: column;


    .logo{

      margin-top: 200px;
      width: 250px;
      height: 200px;
      cursor: pointer;

    }
    
    .enter_site_btn{
      width: auto;
      margin-top: 20px;
      padding: 6px 20px;
      background-color: var(--orange);
      border: none;
      border-radius: 5px;
      cursor: pointer;
    }
    
    
    
  }
  
  


  footer {
    width: auto;
    height: 50px;
    max-height: 50px;
    min-width: 414px;
    max-width: 320px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: var(--mainTextColor);
    padding: 5px;
    margin-top: 30px;
    font-size: 12px;
    font-weight: lighter;
    position: relative;
    //border: 1px solid black;

    @media ${device.tablet} {
      max-width: 768px;
    }


    span {
      color: var(--orange);
      font-weight: normal;
    }

  }

`;





